import React from "react";

const About = () => {
  return (
    // Whole About Div
    <div
      name="about"
      className="w-full bg-gradient-to-b from-gray-800 to-black text-white h-screen"
    >
      {/* Total About Content */}
      <div className="max-w-screen-lg p-4  mx-auto flex flex-col justify-center w-full h-full">
        {/* About Heading */}
        <div className="pb-8">
          <p className="text-3xl md:text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <p data-aos="fade-left" className="text-base md:text-xl">
          Hello! I'm Molla Mainuddin, from Kolkata, also known as Cultural Capital of India.
        </p>

        <br />

        <p data-aos="fade-right" className="text-base md:text-xl">
          I am a creative, time punctual, dedicated, goal-oriented individual with decent moral Values and
          Ethicates along with a high-energy level, honed communication skills, strong organizational skills,
          and meticulous attention to detail.
        </p>

        <br />

        <p data-aos="fade-left" className="text-base md:text-xl">
          I have completed my Bachelors from Kolkata in <span className="text-blue-400">Computer Science and Engineering</span> (2018-2022).
          Currently working in an MNC as <span className="text-blue-400">Jr. Software Engineer</span>.
        </p>

      </div>
    </div>
  );
};

export default About;